module.exports = __webpack_public_path__ + "media/components/journeys/ticket-icons/checkpoint-e3b903cee788875df9972f80cffcd006.png";